<template>
  <div class="concept-list">
      <p v-if="showGroupError" style="text-align: center;">Please go directly to your group's URL.</p>
      <p v-if="$store.state.org.concepts.length == 0 && !showGroupError" style="text-align: center;">Fetching concepts...</p>
      <ConceptSummary
        v-for="(concept, index) in $store.state.org.concepts"
        v-bind:concept="concept"
        v-bind:index="index"
        v-bind:key="concept.id"
        @goToConcept="goToConcept(concept)"
      ></ConceptSummary>
  </div>
</template>

<script>
import ConceptSummary from '@trust/components/ConceptSummary.vue'

export default {
  name: 'ConceptList',
  components: {
    ConceptSummary,
  },
  data() {
      return {
      }
  },
  props: ['showGroupError'],
  computed: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    goToConcept(concept){
      if(this.$store.state.trust.canEdit || this.$store.state.trust.isEditing) {
        return;
      }
      let slug = encodeURIComponent(concept.name.toLowerCase());
      this.$store.dispatch('routing/goToConcept', { slug }, {root: true});
    }
  },
  watch: {
  }
}

</script>

<style>

  .concept-list {
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 10px;
    padding-top: 40px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }

  @media screen and (max-device-width: 600px) and (orientation:landscape) {
    .concept-list {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 10px;
    }

    .concept-list .concept-summary {
      margin-bottom: 4px;
    }
  }

</style>
